import { SC } from "../helper/ServerCall";

export const addressService = {
    getAddressesPagination,
    storeAddress,
    deleteAddress,
    getAddressItem,
    editAddress,
    getAllShippingAddresses,
    getAllBillingAddresses
};

function getAllShippingAddresses() {
    return SC.getCall("address/get-user-addresses/shipping address");
}

function getAllBillingAddresses() {
    return SC.getCall("address/get-user-addresses/billing address");
}

function editAddress(data, id) {
    return SC.putCall("address/" + id, data);
}

function getAddressItem(id) {
    return SC.getCall(`address/${id}`);
}

function getAddressesPagination(
    id,
    model,
    page,
    sort,
    pageSize,
    component_name,
    pagination
) {
    return SC.getCall(
        "address?" +
        "model=" +
        model +
        "&model_id=" +
        id +
        "&page=" +
        page +
        "&sort=" +
        sort +
        "&pageSize=" +
        pageSize +
        "&component_name=" +
        component_name +
        "&paginate=" +
        true
    );
}

function storeAddress(data) {
    return SC.postCall(`address`, data);
}
function deleteAddress(list_id) {
    return SC.deleteCall("address/" + list_id);
}



// WEBPACK FOOTER //
// ./src/services/address.js